import React from 'react';
import './InfoBar.css';
import onlineIcon from '../../icons/online.png';
import closeIcon from '../../icons/close.png';

const InfoBar = ({room}) => {
    return (
        <div className="infoBar" >
            <div className="leftInnerContainer">
                <img className="onlineIcon" src={onlineIcon} alt="Online img" width="32" height="32" />
                <h3>{room}</h3>
            </div>
            <div className="rightInnerContainer">
                <a href="/"><img src={closeIcon} alt="Close Img" width="16" height="16"  /></a>
            </div>
        </div>
    )
}

export default InfoBar
